import React from 'react';
import ReactDOM from 'react-dom';
import App from './web/App';
import "../src/index.css"
import '../node_modules/@fortawesome/fontawesome-free/css/all.css';
import './i18n';

import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
